<template>
  <div id="ManagerSupport">
    <div class="container">
      <h3 class="mt-5">Manager support</h3>
      <div class="referralPage mt-5">
        <b-row>
          <b-col cols="12" md="6" lg="7">
            <p>
              As a manager, you'll know the importance of supporting the health
              and mental wellbeing of your team. If you see that one of your
              employees is struggling, you may want to refer them to our
              Employee Assistance Programme (EAP) for support. A referral
              directs your employee to the appropriate experts and helps them
              feel supported.
            </p>
            <p>
              First, speak with your employee, discuss the process and gain
              their consent to be contacted by our EAP.
            </p>
            <p>
              Please let them know that their information shall be managed
              confidentially, and as the referrer you'll only gain notifications
              when:
            </p>
            <ul>
              <li>
                Support has been put in place, and they have engaged/not
                engaged.
              </li>
              <li>Support has been declined or deemed unsuitable.</li>
              <li>Contact has not been possible on the details provided.</li>
              <li>Support has ended.</li>
            </ul>
            <p>
              Then, contact the EAP team to make a referral through the helpline
              or go directly to the management referral form. Don't forget to
              attach the employee's written consent. Once the form has been
              submitted:
            </p>
            <ul>
              <li>
                Your employee will be contacted within two working days of the
                referral.
              </li>
              <li>
                Where appropriate, they will be offered support and guidance.
              </li>
              <li>
                You'll be told when contact has been made. It's up to the
                individual if they wish to disclose further details.
              </li>
            </ul>
          </b-col>
          <b-col cols="12" md="6" lg="5" class="d-flex flex-column">
            <img
              src="https://media.spectrum.life/assets/axa/manager_support_main.jpg"
              alt="men looking at a computer"
            />
            <b-button
              class="refButton mt-5"
              variant="cta"
              squared
              target="_blank"
              href="https://www.axahealth.co.uk/globalassets/corporate-employee-resource-library/employee-assistance-programme/eap---general/employee-assistance-programme---manager-referral-guide.pdf"
            >
              Manager Referral Guide
            </b-button>
            <b-button
              class="refButton mt-5"
              variant="cta"
              squared
              target="_blank"
              href="https://www.axahealth.co.uk/globalassets/corporate-employee-resource-library/employee-assistance-programme/eap---general/employee-referral-guide2.pdf"
            >
              Employee Referral Guide
            </b-button>
            <b-button
              class="refButton mt-5"
              variant="cta"
              squared
              target="_blank"
              href="https://spectrumlife.my.site.com/axahealth/s/axa-management-referral"
            >
              Manager Referral Form
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>
    <ManagerSupportContent />
  </div>
</template>

<script>
import ManagerSupportContent from "@/components/ManagerSupportContent.vue";

export default {
  name: "ManagerSupportReferral",
  components: { ManagerSupportContent }
};
</script>

<style lang="less">
#ManagerSupportReferral {
  overflow-x: hidden;
  background-color: #fafafa !important;
  h3 {
    font-size: 2.5em;
  }
  p,
  ul {
    font-size: 1.6em;
  }
  .contentGrid {
    display: grid;
    margin: auto;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 32px;
    grid-column-gap: 16px;
    div {
      min-height: 250px;
      h4 {
        font-size: 2em;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
      a {
        border-radius: 10px;
        width: 110px;
      }
    }
  }

  .msButton {
    width: 200px;
    align-self: flex-end;
  }

  #pageNumber {
    display: none !important;
  }

  .referralPage {
    img {
      width: 100%;
      display: block;
    }
  }

  @media (min-width: 1200px) {
    .container {
      max-width: 960px !important;
    }
  }
  @media (max-width: 576px) {
    .contentGrid {
      grid-template-columns: 1fr;
      div {
        min-height: 150px;
      }
      #eapImage {
        grid-row: 4;
      }
    }
  }
}
</style>
